<template>
  <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 0.75C10.8555 0.75 14 3.89453 14 7.75C14 11.6328 10.8555 14.75 7 14.75C3.11719 14.75 0 11.6328 0 7.75C0 3.89453 3.11719 0.75 7 0.75ZM6.34375 4.90625V8.40625C6.34375 8.78906 6.61719 9.0625 7 9.0625C7.35547 9.0625 7.65625 8.78906 7.65625 8.40625V4.90625C7.65625 4.55078 7.35547 4.25 7 4.25C6.61719 4.25 6.34375 4.55078 6.34375 4.90625ZM7 11.6875C7.46484 11.6875 7.84766 11.3047 7.84766 10.8398C7.84766 10.375 7.46484 9.99219 7 9.99219C6.50781 9.99219 6.125 10.375 6.125 10.8398C6.125 11.3047 6.50781 11.6875 7 11.6875Z"
      fill="#191919"
    />
  </svg>
</template>
